import { Security, LoginCallback } from "@okta/okta-react";
import { Routes, Route } from "react-router";
import { oktaAuth } from "./lib/auth";
import { AuthGate } from "./components/AuthGate";
import { PreviewSecurity } from "./components/PreviewSecurity";
import { ConfirmProvider } from "./components/primitives/Confirm";
import { AppRoutes } from "./routes";

/** Everything inside the auth boundary: confirmations, the login callback
 *  route, and the app's routes behind `AuthGate`. */
function Shell() {
  return (
    <ConfirmProvider>
      <Routes>
        <Route path="/login/callback" element={<LoginCallback />} />
        <Route
          path="/*"
          element={
            <AuthGate>
              <AppRoutes />
            </AuthGate>
          }
        />
      </Routes>
    </ConfirmProvider>
  );
}

/**
 * The app root, and the one place that decides which auth provider wraps it:
 * Okta normally, `PreviewSecurity` under `pnpm preview` where `oktaAuth` is
 * null (see `lib/auth.ts`).
 */
export function App() {
  // `oktaAuth` is null only under `pnpm preview` (see lib/auth.ts).
  if (!oktaAuth) {
    return (
      <PreviewSecurity>
        <Shell />
      </PreviewSecurity>
    );
  }
  return (
    <Security
      oktaAuth={oktaAuth}
      restoreOriginalUri={async (_oa, uri) => {
        window.location.replace(uri || "/");
      }}
    >
      <Shell />
    </Security>
  );
}
